import { MutationTree } from 'vuex'
import { ICouponsState, ICouponInformation } from '@/@types'

const mutations: MutationTree<ICouponsState> = {
  COUPON_UPDATED: (state, couponStr: string) => {
    state.couponStr = couponStr
  },
  COUPON_STR_STACK_UPDATED: (state, couponStrStack: string[]) => {
    state.couponStrStack = couponStrStack
  },
  COUPON_OBJ_UPDATED: (state, couponObj: ICouponInformation) => {
    state.couponObj = couponObj
  },
  COUPON_OBJ_STACK_UPDATED: (state, couponObjStack: ICouponInformation[]) => {
    state.couponObjStack = couponObjStack
  },
  COUPON_LOADING_UPDATED: (state, couponLoading: boolean) => {
    state.couponLoading = couponLoading
  },
  COUPON_ELIGIBILITY_UPDATED: (
    state,
    payload: { couponObj: ICouponInformation; isEligible: boolean }
  ) => {
    const { couponObj, isEligible } = payload
    couponObj.isEligibleForCart = isEligible
    state = {
      ...state,
      couponObj,
    }
  },
  COUPON_DISCOUNT_UPDATED: (
    state,
    payload: { couponObj: ICouponInformation; discountAmount: number }
  ) => {
    const { couponObj, discountAmount } = payload
    couponObj.discountAmount = discountAmount
    couponObj.discountAmountCents = Math.round(discountAmount * 100)
    state = {
      ...state,
      couponObj,
    }
  },
  COUPON_DISCOUNT_TOTAL_UPDATED: (
    state,
    payload: { couponTotalDiscount: number; couponTotalDiscountCents: number }
  ) => {
    const { couponTotalDiscount, couponTotalDiscountCents } = payload
    state.couponTotalDiscount = couponTotalDiscount
    state.couponTotalDiscountCents = couponTotalDiscountCents
  },
}

export default mutations
